import axios from "axios";
import { auth } from "./firebase";

const site = axios.create({
  // baseURL: "http://dev.singtico.com/admin/",
  // baseURL: "http://localhost:3000/admin/",
  baseURL:"https://prod.singtico.com/admin/",
});

site.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    localStorage.setItem("@token", token);
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default site;
